import React, { useState, useEffect } from 'react';
import LinkShareModal from '../sharedComponents/LinkShareModal';
import { slugify } from '../../utils/slugify';
import { track } from '../../utils/track';

export const IdioticCardFooter = ({ idioticCardFooterProps }) => {
  const { title, expanded, handleExpandClick, idiotTypes, onUnpop } = idioticCardFooterProps;
  const [modalOpen, setModalOpen] = useState(false);
  const [shareLink, setShareLink] = useState('');

  useEffect(() => {
    setShareLink(`${window.location.origin}/s/${slugify(title)}.html`);
  }, [title]);

  return (
    <div className="card-footer fi-mc-foot">
      <div>
        <button type="button" className="fi-btn fi-btn--sm fi-btn--ink" onClick={() => { track('myth_share_open', { title, placement: 'card_footer' }); setModalOpen(true); }}>
          Share with an idiot
        </button>
        <LinkShareModal link={shareLink} modalOpen={modalOpen} handleCloseModal={() => setModalOpen(false)} idiotTypes={idiotTypes} />
      </div>
      <div className="fi-mc-foot-r">
        {onUnpop && (
          <button type="button" className="fi-link-btn" onClick={() => { track('myth_unpop', { title }); onUnpop(); }}>Re-inflate</button>
        )}
        <button type="button" className="fi-btn fi-btn--sm" onClick={handleExpandClick} aria-expanded={!!expanded}>
          {expanded ? 'Close' : 'Read it all'}
        </button>
      </div>
    </div>
  );
};
